(function(){
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  function money(c){return '$'+(c/100).toFixed(2).replace(/\.00$/,'')}
  function updateCount(){fetch(root+'cart.js').then(function(r){return r.json()}).then(function(c){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;el.hidden=c.item_count===0})}).catch(function(){})}

  function showPopup(msg){
    if(document.getElementById('cc-popup'))return;
    var o=document.createElement('div'); o.id='cc-popup'; o.className='cc-popup';
    o.innerHTML='<div class="cc-popup__box"><div class="cc-popup__ic">&#127874;</div><h3>One more thing</h3><p>'+msg+'</p><button type="button" class="cc-btn cc-btn--primary cc-popup__btn">Return to cart</button></div>';
    document.body.appendChild(o);
    function close(){o.remove()}
    o.querySelector('.cc-popup__btn').addEventListener('click',close);
    o.addEventListener('click',function(e){if(e.target===o)close()});
  }

  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-add-to-cart]');
    if(add){e.preventDefault();var id=add.getAttribute('data-variant-id');if(!id)return;add.disabled=true;
      // one item per order: clear cart, then add exactly 1
      fetch(root+'cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}}).then(function(){
        return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})});
      }).then(function(){window.location.href=root+'cart';}).catch(function(){add.disabled=false;});return;}
    var shop=e.target.closest('[data-shop-toggle]');
    if(shop){e.preventDefault();shop.closest('.cc-shop').classList.toggle('is-open');return;}
    if(!e.target.closest('.cc-shop')){document.querySelectorAll('.cc-shop.is-open').forEach(function(s){s.classList.remove('is-open')})}
    if(e.target.closest('[data-burger]')){document.querySelector('.cc-navlinks').classList.toggle('is-open')}
    var q=e.target.closest('.cc-faq__q');if(q){q.closest('.cc-faq__item').classList.toggle('is-open')}
  });

  // Variant picker (pill buttons) on product page
  function initVariants(){
    document.querySelectorAll('[data-variant-picker]').forEach(function(picker){
      var form=picker.closest('form'); if(!form)return;
      var raw=picker.querySelector('[data-variant-json]'); if(!raw)return;
      var variants; try{variants=JSON.parse(raw.textContent)}catch(err){return}
      var idInput=form.querySelector('[data-variant-id]');
      var addBtn=form.querySelector('[data-add-btn]');
      function chosen(){var arr=[];picker.querySelectorAll('.cc-vopt').forEach(function(o){var a=o.querySelector('.cc-vpill.is-active');arr.push(a?a.getAttribute('data-value'):null)});return arr;}
      function update(){
        var sel=chosen();
        var match=variants.filter(function(v){return (v.options||[]).every(function(ov,i){return ov===sel[i]})})[0];
        if(!match)return;
        if(idInput)idInput.value=match.id;
        document.querySelectorAll('[data-price]').forEach(function(e){e.textContent=money(match.price)});
        if(addBtn){addBtn.disabled=!match.available; if(!match.available){addBtn.textContent='Sold out';}}
      }
      picker.addEventListener('click',function(e){
        var p=e.target.closest('.cc-vpill'); if(!p)return;
        var group=p.closest('.cc-vopt');
        group.querySelectorAll('.cc-vpill').forEach(function(b){b.classList.remove('is-active')});
        p.classList.add('is-active'); update();
      });
      update();
    });
  }

  // save custom line-item property on blur (cart page)
  document.addEventListener('blur',function(e){
    var input=e.target.closest&&e.target.closest('.cc-custom-input[data-prop]');
    if(!input)return;
    var props={}; props[input.getAttribute('data-prop')]=input.value.trim();
    fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(input.getAttribute('data-line')),properties:props})}).then(function(){input.style.borderColor='';}).catch(function(){});
  },true);

  // block checkout until required custom fields filled
  document.addEventListener('click',function(e){
    var co=e.target.closest('[data-cart-checkout], button[name="checkout"]');
    if(!co)return;
    var inputs=document.querySelectorAll('.cc-custom-input[data-prop]'); var bad=null;
    inputs.forEach(function(i){if(!i.value.trim()){bad=i.getAttribute('data-prop'); i.style.borderColor='#dc2626';}else{i.style.borderColor='';}});
    if(bad){e.preventDefault();e.stopPropagation();showPopup('Please add the '+bad.toLowerCase()+' for your order before checking out.');}
  },true);

  var t=document.querySelector('[data-testi]');
  if(t){var slides=[].slice.call(t.querySelectorAll('[data-testi-slide]')),dots=[].slice.call(t.querySelectorAll('[data-testi-dot]')),i=0;
    function show(n){i=(n+slides.length)%slides.length;slides.forEach(function(s,x){s.style.display=x===i?'block':'none'});dots.forEach(function(d,x){d.classList.toggle('is-active',x===i)})}
    t.addEventListener('click',function(e){if(e.target.closest('[data-testi-next]'))show(i+1);if(e.target.closest('[data-testi-prev]'))show(i-1);var d=e.target.closest('[data-testi-dot]');if(d)show(dots.indexOf(d))});
    show(0);setInterval(function(){show(i+1)},6000);
  }

  document.addEventListener('DOMContentLoaded',function(){updateCount();initVariants();});
})();
